import { createContext, useContext } from 'react';

export type SankeyStateHistoryState = {
  canUndo: boolean;
  canRedo: boolean;
  undo: () => void;
  redo: () => void;
};

export const SankeyStateHistoryContext = createContext<SankeyStateHistoryState>(
  {
    canUndo: false,
    canRedo: false,
    undo: () => {},
    redo: () => {},
  }
);

export const useSankeyStateHistoryContext = () =>
  useContext(SankeyStateHistoryContext);
